export const X_SMALL_BREAKPOINT = 568
export const MOBILE_BREAKPOINT = 768
export const TABLET_BREAKPOINT = 1024
